/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { createSelectableContext, use } from 'fierry/react';

import Client from 'solis/navigation/client';
import State from 'solis/navigation/state';
import Level from 'solis/navigation/level';

import PopStateEvent from 'solis/navigation/popstate.event';
import InitializeTrigger from 'solis/navigation/initialize.trigger';

import { argKey } from 'solis/navigation/util';

export { argKey };


const Context = createSelectableContext();


Context.Export = ({ publicArgs, children }) =>
(
  <State.Export publicArgs = {publicArgs}>
    <Client.Export as = {Context} state = {State} publicArgs = {publicArgs}>

      <InitializeTrigger ClientContext = {Context} />
      <PopStateEvent ClientContext = {Context} DispatchContext = {State.Dispatch} />

      {children}

    </Client.Export>
  </State.Export>
);


Context.Dispatch = State.Dispatch;


Object.assign(Context, Level);


export const useArgs = (keys, scope = null) =>
{
  return Object.fromEntries(keys.map(key => [ key, useArg(key, scope) ]));
};


export const useArg = (key, scope = null) =>
{
  key = argKey(scope, key);

  return use(Context(client => client.args[key]));
};


export const useBoundArg = (key, fallback, scope = null) =>
{
  key = argKey(scope, key);

  const dispatch = use(Context.Dispatch);

  const value = useArg(key) ?? fallback;

  const setValue = (value) =>
  {
    dispatch.replaceArgs({ [key]: value });
  };

  return [ value, setValue ];
};


export default Context;
